export const live = {
    zbz: "配信中",
    ljks: "今すぐ開始",
    hmyzb: "まだ配信したことがありません～",
    zbyg: "配信予告",
    yjs: "終了済み",
    jszb: "配信終了",
    gbzb: "配信を閉じる",
    jxzb: "配信を続ける",
    bctp: "画像を保存",
    fxlj: "リンクを共有",
    zbydk: "配信が切断されました。しばらくお待ちください...",
    fh: "戻る",
    wjcdypsb: "オーディオデバイスが検出されません",
    czsb: "Canvas操作に失敗しました:",
    tpjzsb: "画像の読み込みに失敗しました。URLが正しく、画像にアクセスできるか確認してください",
    zbjl: "配信記録",
    sqjl: "申請記録",
    lts: "チャットルーム",
    ren: "人",
    gdcy: "メンバー一覧",
    cy: "メンバー",
    jcjy: "ミュート解除",
    jy: "ミュート",
    qbjy: "全員をミュート",
    zbjs: "配信紹介",
    srnr: "内容を入力してください",
    tczbj: "配信ルームから退出させられました",
    qd: "確定",
    zbjjjs: "配信は10分後に自動終了します！",
    zbsc: "配信時間：",
    ljgkrs: "累計視聴者数：",
    dzs: "いいね数：",
    zbjies: "配信終了",
    ybjy: "ミュートされました",
    jycg: "ミュート解除成功",
    jinycg: "ミュート成功",
    qbjinycg: "全員ミュート成功",
    qbjycg: "全員ミュート解除成功",
    cwzb: "配信者になる",
    lxgzry: "スタッフに連絡して配信者になりましょう",
    lxfs: "連絡方法",
    zb: "配信",
    xkt: "Biking講座",
    sqzb: "配信を申請",
    bczbzt: "今回の配信テーマ",
    srzt: "テーマを入力してください",
    bczbjj: "今回の配信概要",
    kbsj: "配信開始時間",
    xzrisj: "日時を選択",
    tishi: "ヒント",
    dksdzb: "この時間帯に1件の配信予定があります",
    cxsj: "持続時間",
    xzsc: "時間を選択",
    fmt: "カバー画像",
    fmtbnwk: "カバー画像は必須です",
    sc: "アップロード",
    yssc: "最大10MB、圧縮してアップロードしてください",
    sccct: "360*170サイズの画像をアップロードしてください",
    tjsq: "申請を提出",
    tpcj: "画像トリミング",
    tzcjwz: "トリミング枠を調整し、保持する領域を選択してください",
    scdtp: "アップロードされた画像",
    yl: "プレビュー (360×170)",
    cjtp: "画像をトリミング",
    quxiao: "キャンセル",
    qsrzbjj: "配信の概要を入力してください",
    qxzrq: "日付を選択してください",
    qxzsc: "時間を選択してください",
    kssjdydqsj: "開始時間は現在時刻より後に設定してください",
    sctxtpdx: "アップロードする画像サイズは10MBを超えないでください！",
    tjcg: "提出成功",
    jkshnr: "申請内容をできるだけ早く審査します",
    hmysqgzb: "まだ配信を申請したことがありません～",
    shz: "審査中",
    tongg: "承認済み",
    jujue: "拒否",
    yugao: "予告",
    huifang: "録画",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/live/ja_JP.js